import React from 'react';
import { useSite } from '../context/SiteContext';

/**
 * Logo component: shows uploaded logo if available, else animated initials badge.
 * size: 'sm' | 'md' | 'lg'
 */
const Logo = ({ size = 'md', showText = true, className = '' }) => {
  const { content } = useSite();
  const branding = content?.branding || {};
  const hasLogo = !!branding.logoUrl;

  const sizes = {
    sm: { box: 'w-9 h-9', inner: 'inset-1 text-xs', text: 'text-[14px]', tag: 'text-[9px]' },
    md: { box: 'w-10 h-10', inner: 'inset-1 text-sm', text: 'text-[15px]', tag: 'text-[10px]' },
    lg: { box: 'w-14 h-14', inner: 'inset-1.5 text-base', text: 'text-[18px]', tag: 'text-[11px]' },
  };
  const s = sizes[size] || sizes.md;

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {hasLogo ? (
        <div className={`${s.box} rounded-lg overflow-hidden bg-white/5 border border-white/10 flex items-center justify-center flex-shrink-0`}>
          <img
            src={branding.logoUrl}
            alt={branding.companyName || 'Logo'}
            className="w-full h-full object-contain"
          />
        </div>
      ) : (
        <div className={`relative ${s.box} rounded-lg bg-gradient-to-br from-[#00e0c7] to-[#00a3ff] flex items-center justify-center shadow-lg shadow-cyan-500/20 flex-shrink-0`}>
          <div className={`absolute ${s.inner.split(' ')[0]} rounded-md bg-[#0d1b2a] flex items-center justify-center`}>
            <span className={`text-[#00e0c7] font-bold tracking-tight ${s.inner.split(' ').slice(1).join(' ')}`}>
              LD
            </span>
          </div>
        </div>
      )}
      {showText && (
        <div className="text-left leading-none">
          <div className={`text-white font-semibold tracking-tight ${s.text}`}>
            {(branding.companyName || 'Laboratorio.Cine').split('.').map((part, i, arr) => (
              <React.Fragment key={i}>
                {part}
                {i < arr.length - 1 && <span className="text-[#00e0c7]">.</span>}
              </React.Fragment>
            ))}
          </div>
          <div className={`text-white/50 uppercase tracking-[0.18em] mt-1 ${s.tag}`}>
            {branding.tagline || 'Digital Cinema Carrier'}
          </div>
        </div>
      )}
    </div>
  );
};

export default Logo;
